<template>
	<div class="containers">
		<!-- <div class="parking-box">
			农批市场
		</div> -->
		{{ plateNo }}
		<div class="car_input_box">
			<!-- <div>请输入正确的车牌</div> -->
			<div class="car_number_input">
				<div class="car_type">
					<!-- <div class="default_car" :class="{active_car : activeNum == '0'}"
						@click="chooseNumber(carNumber[0],'0')">
						<div class="" v-show="carNumber[0]">
							{{carNumber[0]}}
						</div>
					</div>
					<div class="default_car default_car1" :class="{active_car: activeNum == '1'}"
						@click="chooseNumber(carNumber[1],'1')">
						<div class="" v-show="carNumber[1]">
							{{carNumber[1]}}
						</div>
					</div> -->
					<div class="default_car" :class="{diabled_car : disable}"
						@click="chooseNumber(carNumber[0],'0')">
						<div class="" v-show="carNumber[0]">
							{{carNumber[0]}}
						</div>
					</div>
					<div class="default_car default_car1" :class="{diabled_car: disable}"
						@click="chooseNumber(carNumber[1],'1')">
						<div class="" v-show="carNumber[1]">
							{{carNumber[1]}}
						</div>
					</div>
					<div class="default_dot"></div>
					<div class="default_car" :class="{active_car:activeNum == '2'}"
						@click="chooseNumber(carNumber[2],'2')">
						<div class="" v-show="carNumber[2]">
							{{carNumber[2]}}
						</div>
					</div>
					<div class="default_car" :class="{active_car : activeNum == '3'}"
						@click="chooseNumber(carNumber[3],'3')">
						<div class="" v-show="carNumber[3]">
							{{carNumber[3]}}
						</div>
					</div>
					<div class="default_car" :class="{active_car : activeNum == '4'}"
						@click="chooseNumber(carNumber[4],'4')">
						<div class="" v-show="carNumber[4]">
							{{carNumber[4]}}
						</div>
					</div>
					<div class="default_car" :class="{active_car : activeNum == '5'}"
						@click="chooseNumber(carNumber[5],'5')">
						<div class="" v-show="carNumber[5]">
							{{carNumber[5]}}
						</div>
					</div>
					<div class="default_car" :class="{active_car : activeNum == '6'}"
						@click="chooseNumber(carNumber[6],'6')">
						<div class="" v-show="carNumber[6]">
							{{carNumber[6]}}
						</div>
					</div>
					<div class="default_car"
						:class="{diabled_car:currentIndex != 1,active_car:activeNum == '7' && currentIndex == 1}"
						@click="chooseNumber(carNumber[7],'7')">
						<div class="" v-show="carNumber[7]">
							{{carNumber[7]}}
						</div>
					</div>
				</div>
			</div>
			<div class="check_energy" >
				<van-checkbox v-model="checkbox" @change="chooseIsNewEnergy" checked-color="#3399ff" style="font-size: 20px;margin-top: 10px;">新能源车牌号</van-checkbox>
			</div>
			<!-- <div class="check_energy" >
				<div>
					<img src="../assets//logo.png"  v-if="currentIndex == 1"
						@click="chooseIsNewEnergy">
					<img src="../assets/background.jpg" v-else @click="chooseIsNewEnergy">
				</div>
				<div>新能源车牌号</div>
			</div> -->
			<!-- <div class="confirm_btn" @click="submit"  v-if="keyboardShow">
				确认
			</div> -->
		</div>
		<!-- <div class="tips" v-if="keyboardShow">
			注: 请认真核对车牌，以免支付错误！
		</div> -->
		<!-- 键盘 -->
		<div class="keyboard-content" v-if="keyboardShow">
			<!-- 省份键盘 -->
			<!-- <template v-if="provinceBoardShow">
				<div style="position: relative;">
					<div class="province-keyboard flex jus-center">
						<div class="td-nor color-333 province-td" v-for="(item,index) in provincesKeyList" :key="index"
							@click="provinceKeyClick(item,index)" hover-class="board-active" hover-start-time="0"
							hover-stay-time="80">
							<div class="province-font">
								{{item}}
							</div>
						</div>
					</div>
					<div class="province-keyboard flex jus-center">
						<div class="td-nor color-333 province-td" v-for="(item,index) in provincesKeyTwo" :key="index"
							@click="provinceKeyClick(item,index)" hover-class="board-active" hover-start-time="0"
							hover-stay-time="80">
							<div class="province-font">
								{{item}}
							</div>
						</div>
					</div>
					<div class="province-keyboard flex jus-center">
						<div class="td-nor color-333 province-td" v-for="(item,index) in provincesKeyThree"
							:key="index" @click="provinceKeyClick(item,index)" hover-class="board-active"
							hover-start-time="0" hover-stay-time="80">
							<div class="province-font">
								{{item}}
							</div>
						</div>
					</div>
					<div class="province-keyboard flex">
						<div class="td-nor color-333 province-td" v-for="(item,index) in provincesKeyFour" :key="index"
							@click="provinceKeyClick(item,index)" hover-class="board-active" hover-start-time="0"
							hover-stay-time="80">
							<div class="province-font">
								{{item}}
							</div>
						</div>
					</div>
					<div @click.stop="backspace" class="delete flex del-province">
						<img src="../assets/logo.png" class="del-con" >
					</div>
				</div>
			</template> -->
			<!--数字键盘-->
			<template v-if="!provinceBoardShow">
				<div class="number-keyboard flex between">
					<template>
						<div class="td td-num color-333" :class="numberIsDis ? 'board-active' : ''"
							v-for="(item,index) in numberKeyList" :key="index" @click="numberKeyClick(item,index)"
							:hover-class="numberIsDis ? '' : 'board-active'" hover-start-time="0" hover-stay-time="80">
							{{item}}
						</div>
					</template>
				</div>
			</template>
			<!--字母键盘-->
			<template v-if="!provinceBoardShow">
				<div class="english-keyboard flex between">
					<template>
						<div class="td td-num color-333" :class="englishIsDis ? 'board-active' : ''"
							v-for="(item,idx) in englishKeyOneList" :key="idx" @click="englishKeyClick(item,idx)"
							:hover-class="englishIsDis ? '' : 'board-active'" hover-start-time="0" hover-stay-time="80">
							{{item}}
						</div>
					</template>
				</div>
				<!-- 最后一行 -->
				<div class="english-keyboard flex between">
					<template>
						<div class="td td-num color-333" :class="englishIsDis ? 'board-active' : ''"
							v-for="(item,index) in englishKeyTwoList" :key="index" @click="englishKeyClick(item,index)"
							:hover-class="englishIsDis ? '' : 'board-active'" hover-start-time="0" hover-stay-time="80">
							{{item}}
						</div>
					</template>
 
					<!-- 挂字键 -->
					<template>
						<!-- <div @click="trailerFiledClick('港')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">港</div> -->
						<!-- <div @click="trailerFiledClick('澳')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">澳</div>
						<div @click="trailerFiledClick('学')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">学</div>
						<div @click="trailerFiledClick('挂')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">挂</div>
						<div @click="trailerFiledClick('警')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">警</div> -->
					</template>
					<!-- <div @click.stop="backspace" class="delete flex">
						<img src="../../static/img/del@2x.png" class="del-con" alt="">
					</div> -->
					<div @click.stop="backspace" class="delete flex">
						<img src="../assets/delete2.jpg" class="del-con" >
					</div>
					<div @click.stop="submit" class="delete flex" style="font-size: 18px;background-color: #00cc33;color: white;">
						完成
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
 
<script>
import { Notify } from 'vant';
import store from '@/store/index.js'
import { WarningMsgBox } from '../my_js/common';
	export default {
		name: "add-car-input",
		data() {
			return {
				checkbox:false,//新能源选择框
				disable:true,//车牌号1、2位禁用
				keyboardShow:false,
				current: 0,
				carNumber: ['冀','A'],//初始车牌号码
				carTypeList: [{
					text: '新能源',
					value: 1,
				}],
				currentIndex: 0,//是否新能源，0：普通车，1：新能源车
				// provincesKeyList: '京津冀晋蒙辽吉黑',
				// provincesKeyTwo: '沪苏浙皖闽赣鲁豫',
				// provincesKeyThree: '鄂湘粤桂琼渝川贵',
				// provincesKeyFour: '云藏陕甘青宁新',
				provinceBoardShow: true, // 省键盘
				numberKeyList: '1234567890',
				numberIsDis: true, // 输入键盘不可点击 true为不可点击
				englishIsDis: false, // 字母键盘可点击
				englishKeyOneList: 'ABCDEFGHJKLMNPQRSTUV',
				englishKeyTwoList: 'WXYZ',
				trailerFiledIsDis: true, // 挂字禁用
				activeNum: '2',//当前激活的车牌号位数索引
				isClickCarNum: false,
				isCheckEnergy: false,
				station:null,//接收父组件传过来的号牌领取点
			};
		},
		watch: {
			'carNumber.length': {
				handler(newVal, oldValue) {
					console.log(newVal, oldValue, 'newVal, oldValue')
					this.setTrailerKeyboardDis()
				},
				deep: true
			}
		},
		created(){
			console.log(store.state.plateNo);
			if(store.state.plateNo){
				this.carNumber = store.state.plateNo
			}
			console.log(store.state.getStation);
			// this.station = this.getStation
		},
		// 接收父组件的车牌号
		props:{
			plateNo:{
				type:String,
				default:''
			},
			// getStation:{
			// 	type:String,
			// 	default:''
			// }
		},
		methods: {
			//  确定按钮
			submit() {
				// //普通车车牌校验
				// const carCardP =
				// 	/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

				// //新能源车牌校验
				// const carCardD =
				// 	/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;	
				// if (this.carNumber.length == 2) {
				// 	// this.$message({
				// 	// 	message:'请输入车牌号',
				// 	// 	type:'warning',
				// 	// 	duration:2000
				// 	// })
				// 	Notify({type:'warning',message:'请输入车牌号',duration:2000})
				// 	this.keyboardShow=false
				// 	return;
				// }
				// if (!carCardP.test(carPlate) && (this.currentIndex == 0)) {
				// 	console.log(carCardP.test(carPlate));
				// 	console.log(typeof(carCardP.test(carPlate)));
				// 	console.log(typeof(carPlate));
				// 	// 普通车
				// 	// this.$message({
				// 	// 	message:'车牌号输入有误',
				// 	// 	type:'error',
				// 	// 	duration:2000
				// 	// })
				// 	Notify({type:'warning',message:'车牌号输入有误',duration:2000})
				// 	this.keyboardShow=false
				// 	return;
				// }
				// if (!carCardD.test(carPlate) && this.currentIndex == 1) {
				// 	// 新能源
				// 	// this.$message({
				// 	// 	message:'车牌号输入有误',
				// 	// 	type:'error',
				// 	// 	duration:2000
				// 	// })
				// 	Notify({type:'warning',message:'车牌号输入有误',duration:2000})
				// 	this.keyboardShow=false
				// 	return;
				// }
				let carPlate = this.carNumber.join('')
				console.log(this.carNumber, carPlate, 'carNumber')
				if (this.carNumber.length == 2) {
					Notify({type:'warning',message:'请输入车牌号',duration:2000})
					this.keyboardShow=false
					return;
				}else if( (this.currentIndex == 0 && carPlate.length != 7) || (this.currentIndex == 1 && carPlate.length != 8)){
					Notify({type:'warning',message:'请输入正确的车牌号码',duration:2000})
				}
				this.$emit('func',carPlate)
				this.keyboardShow=false
			},
			// 点击车牌号输入框
			// chooseNumber(item, active) {
			// 	console.log(item, active, 'itemsss')
			// 	if (active == 1) {
			// 		// 第二位
			// 		this.numberIsDis = true
			// 		this.provinceBoardShow = false
			// 	} else if (active == '0') {
			// 		// 第一位
			// 		this.provinceBoardShow = true
			// 		this.numberIsDis = true
			// 	} else {
			// 		this.numberIsDis = false
			// 		this.provinceBoardShow = false
			// 	}
			// 	if (this.currentIndex == 0 && active == '7') {
			// 		// 普通车牌 不让点击一位
			// 	} else {
			// 		this.activeNum = active
			// 		this.current = active
			// 		this.isClickCarNum = true
			// 	}
			// 	if ((this.currentIndex == 0 && this.carNumber.length >= 6 && this.current >= 6) || (this.currentIndex ==
			// 			1 && this.carNumber
			// 			.length >= 7 && this.current >= 7)) {
			// 		this.trailerFiledIsDis = false;
			// 	} else {
			// 		this.trailerFiledIsDis = true;
			// 	}
			// },
			chooseNumber(item, active) {
				// 业务受理点信息
				this.station = store.state.stationInfo
				console.log('station',this.station);
				// debugger
				if(this.station == null || this.station == ''){
					return WarningMsgBox('请先选择业务受理点')
				}
				console.log(item, active, 'itemsss')
				if(active >= '2') {
					this.keyboardShow = true
					this.numberIsDis = false
					this.provinceBoardShow = false
				}
				if ((this.currentIndex == 0 && active == '7')||active == '0' || active== '1') {
				// if (this.currentIndex == 0 && active == '7') {
				// 普通车牌 不让点击一位
				} else {
					this.activeNum = active
					this.current = active
					this.isClickCarNum = true
				}
				if ((this.currentIndex == 0 && this.carNumber.length >= 6 && this.current >= 6) || (this.currentIndex ==
						1 && this.carNumber
						.length >= 7 && this.current >= 7)) {
					this.trailerFiledIsDis = false;
				} else {
					this.trailerFiledIsDis = true;
				}
			},
			// 点击新能源或者普通车
			chooseIsNewEnergy() {
				// debugger
				console.log(this.carNumber, '切换新能源')
				if (this.currentIndex == 1) {
					this.currentIndex = 0
					if (this.carNumber.length == 8) {
						this.carNumber.pop()
					}
				} else {
					this.currentIndex = 1
					if (this.carNumber.length == 7) {
						this.current = 7
						this.activeNum = 7
					}
				}
				console.log(this.carNumber, '切换新能源后')
				this.$forceUpdate()
				this.$emit('plateType',this.currentIndex)
			},
			// 省份键盘
			// provinceKeyClick(val, index) {
			// 	console.log(this.currentIndex, this.carNumber.length, 'this.carNumber.length省')
			// 	this.carNumber[0] = val
			// 	this.provinceBoardShow = false
			// 	this.numberIsDis = true;
			// 	this.englishIsDis = false;
			// 	this.current++
			// 	this.activeNum = this.current
			// 	this.$forceUpdate()
			// 	console.log(this.current, 'current')
			// },
			// 数字键盘
			numberKeyClick(val, idx) {
				let flag = this.carNumber.indexOf("") === -1
				console.log(this.currentIndex, this.carNumber, flag, this.carNumber.length, 'this.carNumber.length数字')
				if (this.numberIsDis) return
				if ((this.currentIndex == 0 && this.carNumber.length >= 7 && this.current >= 7) || (this.currentIndex ==
						1 && this.carNumber.length >= 8 && this.current >= 8)) {
					return
				}
				console.log(111)
				this.current++
				this.carNumber[this.current - 1] = val;
				this.setTrailerKeyboardDis()
				this.$forceUpdate()
				this.activeNum = this.current
				this.numberIsDis = false
				console.log(this.current, 'current')
				console.log(this.currentIndex, this.carNumber, flag, this.carNumber.length, 'this.carNumber.length数字后')
				// 把车牌号传给父组件
				let carPlate = this.carNumber.join('')
				this.$emit('func',carPlate)
				this.$emit('plateType',this.currentIndex) //车牌类型传给父组件
				
			},
			// 字母键盘
			englishKeyClick(val, idx) {
				let flag = this.carNumber.indexOf("") === -1
				console.log(this.currentIndex, this.carNumber, flag, this.carNumber.length, 'this.carNumber.length字母')
				// this.activeNum = this.carNumber.length
				if (this.englishIsDis) return
				if ((this.currentIndex == 0 && this.carNumber.length >= 7 && this.current >= 7) || (this.currentIndex ==
						1 && this.carNumber.length >= 8 && this.current >= 8)) {
					return
				}
				console.log(222)
				this.current++
				this.carNumber[this.current - 1] = val;
				console.log(this.current, 'this.current 字母键盘')
				if (this.current == 2) this.numberIsDis = false;
				this.setTrailerKeyboardDis()
				this.$forceUpdate()
				this.activeNum = this.current
				this.numberIsDis = false
				console.log(this.current, 'current')
				console.log(this.currentIndex, this.carNumber, flag, this.carNumber.length, 'this.carNumber.length字母后')
				let carPlate = this.carNumber.join('')
				this.$emit('func',carPlate)
			},
			// 设置挂车键盘禁用（只能最后一个选择挂）
			setTrailerKeyboardDis() {
				if ((this.currentIndex == 0 && this.carNumber.length >= 6 && this.current >= 6) || (this.currentIndex ==
						1 && this.carNumber
						.length >= 7 && this.current >= 7)) {
					this.trailerFiledIsDis = false;
				} else {
					this.trailerFiledIsDis = true;
				}
			},
			// 点击挂字
			trailerFiledClick(val) {
				console.log(val, this.trailerFiledIsDis, '挂字')
				if (this.trailerFiledIsDis) return
				if ((this.currentIndex == 0 && this.carNumber.length >= 7 && this.current >= 7) || (this.currentIndex ==
						1 && this.carNumber.length >= 8 && this.current >= 8)) {
					console.log(111222)
					return
				}
				this.current++
				this.carNumber[this.current - 1] = val;
				this.activeNum = this.current
				this.$forceUpdate()
				console.log(this.carNumber, this.current, 'gua')
			},
			// // 删除键
			// backspace() {
			// 	debugger
			// 	console.log('当前选中的索引号:',this.current )
			// 	if (this.current < 0) return
			// 	if (this.current == 0) {
			// 		this.provinceBoardShow = true
			// 		this.activeNum = 0
			// 		this.carNumber[0] = ''
			// 		console.log(this.carNumber[0], 'this.carNumber[0]')
			// 		this.$forceUpdate()
			// 		return
			// 		// this.numberIsDis = true
			// 		// this.englishIsDis = true
			// 		// this.trailerFiledIsDis = true
			// 	} else if (this.current == 1) {
			// 		this.provinceBoardShow = true
			// 		this.activeNum = 1
			// 		this.carNumber[1] = ''
			// 	} else if (this.current == 2) {
			// 		this.provinceBoardShow = false
			// 		this.numberIsDis = true
			// 		this.carNumber[this.current] = ''
			// 	} else {
			// 		this.provinceBoardShow = false
			// 		this.carNumber[this.current - 1] = ''
			// 	}
			// 	if ((this.currentIndex == 0 && this.current <= 6) || (this.currentIndex == 1 && this.current <= 7)) {
			// 		this.trailerFiledIsDis = true;
			// 	} else {
			// 		this.trailerFiledIsDis = false;
			// 	}
			// 	this.current--
			// 	this.activeNum = this.current
			// 	this.$forceUpdate()
			// 	console.log(this.carNumber, '删除后车牌号')
			// },
			// 删除键
			backspace() {
				console.log('当前选中的索引号:',this.current )
				this.numberIsDis = false //数字键盘,true不可点击
				if(this.current == 2){
					this.carNumber[2] = ''
				}
				else {
					this.carNumber[this.current] = ''
					this.current--
				}
				this.activeNum = this.current
				this.$forceUpdate()
				console.log(this.carNumber, '删除后车牌号')
			},
			// 重置车牌号
			// resetData(){
			// 	this.carNumber= ['冀','A']
			// },
			resetData(val){
				// debugger
				if(val){
					console.log('carNumber',this.carNumber);
					store.commit('setPlateNo', this.carNumber)
				}else{
					this.carNumber= ['冀','A']
					// store.commit('setPlateNo', this.carNumber)
				}
			},
			// 隐藏键盘
			hideKeyboard(){
				// this.keyboardShow=false
				let carPlate = this.carNumber.join('')
				if(carPlate.length > 2){
					this.submit()
				}else{
					this.keyboardShow=false
				}
			},
		}
	}
</script>
 
<style lang="scss" scoped>
	.containers {
		box-sizing: border-box;
		width: 90%;
		// border: red 1px solid;
	}
 
	// .parking-box {
	// 	width: 100%;
	// 	height: 254px;
	// 	background: linear-gradient(180deg, #11B690 0%, #11B690 100%);
	// 	font-size: 44px;
	// 	font-family: PingFangSC-Semibold, PingFang SC;
	// 	font-weight: 600;
	// 	color: #FFFFFF;
	// 	text-align: center;
	// 	padding-top: 52px;
	// 	box-sizing: border-box;
	// }
 
	.car_input_box {
		// width: 702px;
		// height: 440px;
		// background: #edf4ff;
		// box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.06);
		border-radius: 12px;
		// margin: -86px auto 0;
		font-size: 28px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		text-align: center;
		// padding: 40px 20px;
		box-sizing: border-box;
	}
 
	@keyframes fade {
		from {
			opacity: 1.0;
		}
 
		50% {
			opacity: 0;
		}
 
		to {
			opacity: 1.0;
		}
	}
 
	@-webkit-keyframes fade {
		from {
			opacity: 1.0;
		}
 
		50% {
			opacity: 0;
		}
 
		to {
			opacity: 1.0;
		}
	}
 
	.flex {
		display: flex;
	}
 
	.between {
		justify-content: space-between;
		align-items: center;
	}
 
	.font-30 {
		font-size: 30px;
	}
 
	.color-333 {
		color: #333333;
	}
 
	.car_type {
		display: flex;
		justify-content: space-between;
		margin: 0 auto;
		width: 100%;
		align-items: center;
	}
 
	.default_car {
		width: 72px;
		height: 55px;
		// background: #FFFFFF;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.1);
		text-align: center;
		line-height: 55px;
		font-size: 30px;
		font-weight: bold;
		color: #333333;
 
 
	}
 
	.line {
		color: #EA4070;
		border-radius: 2px;
		animation: fade 1500ms infinite;
		-webkit-animation: fade 1500ms infinite;
	}
 
	.car_type_box {
		display: flex;
		justify-content: start;
		width: 390px;
		margin: 0 auto;
 
 
	}
 
	.car_type_item {
		width: 130px;
		height: 69px;
		border: 1px solid #999999;
		text-align: center;
		line-height: 69px;
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}
 
	.check_energy {
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6D7278;
		display: flex;
		justify-content: flex-end;
		// margin-top: 16px;
	}
 
	.check_energy img {
		width: 32px;
		height: 32px;
		margin-right: 8px;
	}
 
	.car_type_item:nth-child(1) {
		border-radius: 6px 0px 0px 6px;
		border-right: 0.5px solid #999999;
	}
 
	.car_type_item:nth-child(2) {
		border-right: none;
		border-left: none;
	}
 
	.car_type_item:nth-child(3) {
		border-radius: 0px 6px 6px 0px;
	}
 
	.active {
		width: 130px;
		height: 69px;
		border: 1px solid #999999;
		text-align: center;
		line-height: 69px;
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: 500;
		font-weight: bold;
		color: #EA4070;
		background: rgba(#EA4070, .1);
	}
 
	.active:nth-child(1) {
		border-radius: 6px 0px 0px 6px;
		border-right: 0.5px solid #999999;
	}
 
	.active:nth-child(2) {
		border-right: none;
		border-left: none;
	}
 
	.active:nth-child(3) {
		border-radius: 0px 6px 6px 0px;
	}
 
	.car_number_input {
		// margin-top: 40px;
	}
 
	.tips {
		font-size: 15px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: red;
		margin: 16px 24px;
	}
 
	.add_car_box {
		width: calc(100% - 64px);
		height: 80px;
		background: linear-gradient(180deg, #DF4270, #F299AB);
		border-radius: 40px;
		margin: 0 auto;
 
 
	}
 
	.add_car {
		height: 100%;
		line-height: 80px;
		font-size: 34px;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
	}
 
	.dis_car {
		height: 100%;
		line-height: 80px;
		font-size: 34px;
		font-weight: 500;
		color: #FFFFFF;
		background: #999999;
		text-align: center;
		border-radius: 40px;
	}
 
	.keyboard-content {
		width: 100%;
		height: 230px;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: rgba(205, 208, 212, 1);
		padding-top: 13px;
		z-index: 1;
 
	}
 
	.td {
		font-family: "PingFangSC";
		font-size: 25px;
		color: #333333;
		font-weight: 500;
		margin: 5px 1px;
		background: #FCFCFE;
		box-shadow: 0px 2px 0px 0px #898A8D;
		border-radius: 9px;
		height: 45px;
		line-height: 45px;
		text-align: center;
		background-color: #fff;
	}
 
	.province-keyboard {
		margin: 0 5px;
		padding: 0 10px;
		// flex-wrap: wrap;
 
 
	}
 
	.td-nor {
		// flex: 0 1 9%;
		// margin-right: 3px;
	}
 
	.number-keyboard {
		margin: 0 5px;
 
 
	}
 
 
	.board-active {
		box-shadow: 0 0 0 #e5e5e5;
		background: #e5e5e5;
	}
 
	.english-keyboard {
		margin: 0 5px;
		flex-wrap: wrap;
 
 
	}
 
	.td-num {
		flex: 0 1 9%;
	}
 
	.board-active {
		box-shadow: 0 0 0 #e5e5e5;
		background: #e5e5e5;
	}
 
	.delete {
		width: 80px;
		height: 45px;
		text-align: center;
		background-color: #AAADB7;
		border-radius: 8px;
		// position: absolute;
		// right: 8px;
		// bottom: 30px;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 2px 0px 0px #898A8D;
	}
 
	.del-province {
		position: absolute;
		right: 28px;
		bottom: 13px;
		width: 64px;
		box-shadow: 0px 2px 0px 0px #898A8D;
		border-radius: 9px;
		font-family: "PingFangSC";
		font-size: 34px;
		color: #333333;
		font-weight: 500;
		// margin: 12px auto;
		background: #FCFCFE;
		box-shadow: 0px 2px 0px 0px #898A8D;
		border-radius: 9px;
		height: 84px;
		line-height: 84px;
		text-align: center;
		background: #AAADB7;
	}
 
	.sure {
		width: 100px;
		height: 84px;
		text-align: center;
		background-color: #AFB2BC;
		border-radius: 8px;
		position: absolute;
		right: 10px;
		bottom: 30px;
		justify-content: center;
		align-items: center;
	}
 
	.default_dot {
		width: 8px;
		height: 8px;
		background: #333333;
		margin: 0 4px;
	}
 
	.del-con {
		width: 44px;
		height: 32px;
	}
 
	.jus-center {
		justify-content: center;
	}
 
	.diabled_car {
		background: #F5F5F5;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.1);
	}
 
	.active_car {
		border-radius: 4px;
		border: 2px solid #375DE9;
	}
 
	.province-mr {
		margin-right: 10px;
	}
 
	.confirm_btn {
		// width: 662px;
		height: 42px;
		line-height: 42px;
		background: #11B690;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		border-radius: 46px;
		// margin-top: 40px;
	}
 
	.province-td {
		width: 12.5%;
	}
 
	.province-font {
		width: 64px;
		box-shadow: 0px 2px 0px 0px #898A8D;
		border-radius: 9px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-size: 34px;
		color: #000;
		font-weight: 500;
		margin: 12px auto;
		box-shadow: 0px 2px 0px 0px #898A8D;
		border-radius: 9px;
		height: 84px;
		line-height: 84px;
		text-align: center;
		background-color: #fff;
	}
 
	.confirm-cash-box {
		width: 100vh;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 99;
	}
 
	.cash-box {
		width: 570px;
		//height: 300px;
		background: rgb(223, 223, 223);
		border-radius: 28px;
		margin: 30vh auto 0;
		text-align: center;
		min-height: 200px;
	}
 
	.cash-title {
		font-size: 34px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #000000;
		padding-top: 38px;
		margin: 0 0 24px;
	}
 
	.content-cash {
		font-size: 26px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #000000;
		margin-bottom: 54px;
		padding: 0 32px;
	}
 
	.line-cash {
		width: 100%;
		height: 1px;
		background: rgba(60, 60, 67, 0.29);
	}
 
	.cancel-box {
		width: 100%;
		height: 88px;
		line-height: 88px;
		color: #11B690;
		font-size: 32px;
		text-align: center;
	}
 
	.flex-btwn {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>